export default {
  getJobListingSearch: (state) => state.jobListingSearch,
};
